import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EmployeeDesignationDTO} from '../dto/employee-designation.model';
import {Observable} from 'rxjs/internal/Observable';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class EmployeeDesignationService {
  employeeDesignationSearchDetailsChange = new EventEmitter<EmployeeDesignationDTO[]>();
  private employeeDesignationSearchDetailsItem: EmployeeDesignationDTO[] = [];


  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /** get all employee designation details **/
  getAllEmployeeDesignation() {
    return this.httpClient.get(this.BASE_URL + 'employeeDesignation' + "/")
  }

  /** Save Employee Designations **/
  saveEmployeeDesignations(designationDTO: EmployeeDesignationDTO) {
    return this.httpClient.post(this.BASE_URL + 'employeeDesignation/save' , designationDTO,{responseType: 'text'});
  }

  /** Search Employee Designation Details **/
  getEmployeeDesignationDetails(designationDTO: EmployeeDesignationDTO) {
    return this.httpClient.post(this.BASE_URL + 'employeeDesignation/', designationDTO, { headers: this.headers });
  }

  /** reset searched details **/
  clearUserRoleSearchDetails() {
    this.employeeDesignationSearchDetailsItem = [];
    this.employeeDesignationSearchDetailsChange.emit(this.employeeDesignationSearchDetailsItem);
  }

  /** set search details in the table **/
  setUserRoleSearchDetails(employeeSearchDetails: EmployeeDesignationDTO[]) {
    this.employeeDesignationSearchDetailsItem = employeeSearchDetails;
    this.employeeDesignationSearchDetailsChange.emit(this.employeeDesignationSearchDetailsItem);
  }

  /** Delete Employee Designation by designation code **/
  deleteDesignation(code: string): Observable<Object>  {
    return this.httpClient.delete(this.BASE_URL + 'employeeDesignation/delete/'+ code );
  }
}
